/*
 * A suspend element represents pagination within the survey
 */

import React from 'react'
import styled from 'react-emotion'
import { color } from 'stylist'
import { Block } from 'slate'

const RemoveIconStyled = styled.span`
  width: 15px;
  height: 15px;
  margin-right: 2px;
  color: ${color('slate')};
`

const RemoveIcon = props => (
  <RemoveIconStyled className={'ion-android-cancel'} />
)

const RemovePageBreakParagraph = styled.p`
  visibility: hidden;
  height: 100%;
  color: ${color('slate')};
  font-size: 13px;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  margin: auto;
  span {
    cursor: pointer;
  }
  &:hover {
    span {
      visibility: visible;
      &:hover {
        color: ${color('red')};
        ${RemoveIconStyled} {
          color: ${color('red')};
        }
      }
    }
  }
`

const RemovePageBreak = ({ editor, node }) => (
  <RemovePageBreakParagraph>
    <span onClick={ev => editor.blur().destructureElement(node)}>
      <RemoveIcon /> Remove Page Break
    </span>
  </RemovePageBreakParagraph>
)
const PageBreakGap = styled.div`
  height: 29px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: -20px;
  margin-right: -20px;
  background-color: ${color('offWhite')};
  &:hover {
    ${RemovePageBreakParagraph} {
      visibility: visible;
    }
  }
`

const PageBreakWrapper = styled.div`
  margin-bottom: 10px;
`

const PageBreak = props => (
  <PageBreakWrapper className={'element-page-break'} contentEditable={false}>
    <PageBreakGap>
      <RemovePageBreak {...props} />
    </PageBreakGap>
  </PageBreakWrapper>
)

const hasContentBetweenNodeAndPageBreak = (editor, node, after = false) => {
  const { document } = editor.value
  let hasContent = false
  let currentNode = node

  const iteratorFunc = after
    ? editor.value.document.getNextSibling.bind(document)
    : editor.value.document.getPreviousSibling.bind(document)

  while ((currentNode = iteratorFunc(currentNode.key))) {
    if (currentNode.type === 'pageBreak') {
      break
    }
    if (currentNode.text) {
      hasContent = true
      break
    }
  }

  const isEnd = !currentNode
  return after ? hasContent || isEnd : hasContent
}

const hasContentBeforeNode = (editor, node) =>
  hasContentBetweenNodeAndPageBreak(editor, node)
const hasContentAfterNode = (editor, node) =>
  hasContentBetweenNodeAndPageBreak(editor, node, true)

const canConvertToPageBreak = (editor, node) => {
  return (
    !node.text.trim() &&
    hasContentBeforeNode(editor, node) &&
    hasContentAfterNode(editor, node)
  )
}

const PageBreakPlugin = () => {
  return {
    schema: {
      blocks: {
        pageBreak: {
          parent: { object: 'document' },
          isVoid: true
        }
      }
    },
    normalizeNode(node, editor, next) {
      let lastElementType

      if (node.object !== 'document') return next()

      node.nodes.forEach((n, ix) => {
        const isPageBreak = editor.isNodeType(n, 'pageBreak')

        if (isPageBreak && (ix === 0 || lastElementType === 'pageBreak')) {
          editor.removeNodeByKey(n.key)
        }
        lastElementType = n.type
      })
    },
    onConstruct(editor, next) {
      editor.registerHoverMenuButton('addPageBreak', {
        label: 'Add Page Break',
        icon: 'ion-code-working',
        type: 'page_break',
        show: node => {
          return canConvertToPageBreak(editor, node)
        }
      })
      return next()
    },
    commands: {
      addPageBreak(editor, node) {
        const { document } = editor.value

        if (canConvertToPageBreak(editor, node)) {
          if (!document.getNextSibling(node.key)) {
            editor.insertLineGroupAfter(node)
          }
          editor.replaceNodeByKey(node.key, Block.create('pageBreak'))
        }
      }
    },
    renderNode(props, editor, next) {
      switch (props.node.type) {
        case 'pageBreak':
          return <PageBreak {...props} />
        default:
          return next()
      }
    }
  }
}

export default PageBreakPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/PageBreakPlugin.js